/**
 *
 * @param width
 * @param height
 * @param facingMode  true for front cam. and false for back cam.
 * @returns
 */

interface INewNavigator extends Navigator {
  webkitGetUserMedia?: any
  mozGetUserMedia?: any
  msGetUserMedia?: any
}

interface INewWindow extends Window {
  webkitURL?: any
  mozURL?: any
  msURL?: any
  URL?: any
}

interface INewVideo extends HTMLVideoElement {
  mozSrcObject?: any
  srcObject: any
  src: any
}

interface INewMediaTrackConstraints extends MediaTrackConstraints {
  focusMode?: any
  resizeMode?: any
}

interface INewOptions {
  width: number
  height: number
  facingMode?: boolean
}

interface INewEvent extends Event {
  errorType: string
  msg: string
  action: () => void
}

const deviceType = (() => {
    const ua = navigator.userAgent
    let isWindowsPhone = /(?:Windows Phone)/.test(ua)
    let isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone
    let isAndroid = /(?:Android)/.test(ua)
    let isFireFox = /(?:Firefox)/.test(ua)
    let isChrome = /(?:Chrome|CriOS)/.test(ua)
    let isTablet =
      /(?:iPad|PlayBook)/.test(ua) ||
      (isAndroid && !/(?:Mobile)/.test(ua)) ||
      (isFireFox && /(?:Tablet)/.test(ua))
    let isPhone = /(?:iPhone)/.test(ua) && !isTablet
    let isPc = !isPhone && !isAndroid && !isSymbian
    return {
      isTablet,
      isPhone,
      isAndroid,
      isPc,
    }
  })()

async function chooseCamera() {
  let deviceVideos: Array<MediaDeviceInfo | any> = [] // 存储设备源ID
  let devices: any = await navigator.mediaDevices.enumerateDevices();
  ((devices: any) => {
    devices.forEach((dv: any) => {
      let kind = dv.kind
      if (kind.match(/^video.*/)) {
        deviceVideos.push(dv)
      }
    })
  })(devices)
  return deviceVideos
}

export async function getDefaultCameraID() {
  let deviceArray = await chooseCamera()
  let [defaultCamera] = deviceArray.filter((device: MediaDeviceInfo) => {
    return !device.label.includes('#')
  })
  return defaultCamera.deviceId
}

function initUserMedia() {
  let navigator: INewNavigator = window.navigator
  navigator.getUserMedia =
    navigator.getUserMedia ||
    navigator.webkitGetUserMedia ||
    navigator.mozGetUserMedia ||
    navigator.msGetUserMedia
  let newWindow: INewWindow = window
  window.URL = newWindow.URL || newWindow.webkitURL || newWindow.mozURL || newWindow.msURL
  return navigator
}

async function getMedia(video: INewVideo, options?: INewOptions) {
  let { width = 600, height = 400, facingMode = false } = options || {
    width: 600,
    height: 400,
    facingMode: false,
  } // default back  camera
  const navigator = window.navigator
  // android设备及pc端
  if (navigator.getUserMedia) {
    const constraints = { video: {}, audio: false }
    if (deviceType.isAndroid) {
      constraints.video = {
        // width,
        // height,
        facingMode: facingMode ? 'user' : 'environment', // 强制使用后置摄像头， user for 前置摄像头
        focusMode: 'auto',
        resizeMode: true,
      }
    } else if (deviceType.isPc) {
      constraints.video = {
        optional: [
          {
            sourceId: await getDefaultCameraID(),
          },
        ],
      }
    }
    if (Promise) {
      return new Promise((res, rej) => {
        navigator.getUserMedia(
          constraints,
          (stream: any) => {
            res(stream)
          },
          erMsg => {
            rej(erMsg)
          },
        ) // success是获取成功的回调函数
      })
    } else {
      alert('Your should update the browser!')
    }
  } else if (navigator.mediaDevices.getUserMedia) {
    // ios设备 或 其他设备
    video.setAttribute('autoplay', '')
    video.setAttribute('muted', '')
    video.setAttribute('playsinline', '')
    const mediaObject: INewMediaTrackConstraints = {
      facingMode: facingMode ? 'user' : 'environment',
      focusMode: 'auto',
      resizeMode: true,
    }
    return navigator.mediaDevices.getUserMedia({
      video: mediaObject,
    })
  } else {
    console.error('Native device media streaming (getUserMedia) not supported in this browser.')
  }
}

function successFunc(video: INewVideo, stream: any) {
  // alert('Succeed to get media!')
  if (video.mozSrcObject !== undefined) {
    // Firefox中，video.mozSrcObject最初为null，而不是未定义的，我们可以靠这个来检测Firefox的支持
    video.mozSrcObject = stream
  } else if ('srcObject' in video) {
    // 笔记本开启摄像头
    video.srcObject = stream
  } else {
    (video as INewVideo).src = window.URL.createObjectURL(stream) || stream
  }

  video.play()
  return { video, stream }
}

function errorFunc(e: Error) {
  // Temporarily treat other types of errors （ except permisson ） as camerabusy
  const type = e.message.toLowerCase().includes('permission') ? 'permission' : 'camerabusy'
  const ev = document.createEvent('HTMLEvents') as INewEvent
  ev.initEvent(`on${type}`, false, false)
  ev.errorType = type
  ev.msg = e.message
  ev.action = () => {
    location.reload()
  }
  document.dispatchEvent(ev)
  return null
}

async function openCamera($video: INewVideo, options?: INewOptions) {
  initUserMedia()

  return await getMedia($video, options)
    .then((stream: any) => successFunc($video, stream))
    .catch(errorFunc) // reutrn a promise object: { video , stream }
}

export default openCamera
